import { jsx, jsxs } from 'react/jsx-runtime';
import BrandclubPhoneInput, { BCPhoneInputVariant } from '../BrandclubPhoneInput/index.js';
import { PopupDrawer } from '../PopupDrawer/PopupDrawer.js';
import { useState, useEffect } from 'react';
import { RewardTable } from './RewardTable.js';
import { ArrowLink } from './ArrowLink.js';
import { BrandclubVideo } from '../BrandclubVideo.js';
import { SharePage } from './SharePage.js';
import { trackRetailerProductPageEvent, buildTrackingParams } from '../../../utils/analytics.js';
import { getAssetNameFromUrl } from '../../../utils/assetUtils.js';
import { ProductPageDialogSuccess } from './ProductPageDialogSuccess.js';
import { ProductPageDialogContent } from './ProductPageDialogContent.js';
import { AnalyticsTrackingEvent } from '../../../analytics/events.js';

const ProductPageDialogMain = ({ popupDrawerProps: { open, onClose }, showIcon, imageUrl, imageSize = 51, title, secondTitle, subtitle, phoneInput, redirect, sharePage, sharePageUrl, onShareLinkCopied, rewardTableRows, video, Link, mainEntity, trackingParams, retailerPDPNavigationEventParams, trackRetailerPDPNavigation, analyticsTrack, handleSendText, userProfile, }) => {
    const [step, setStep] = useState(0);
    const onTextSent = () => setStep(1);
    const handleClose = () => {
        if (step !== 0) {
            setStep(0);
        }
        onClose();
    };
    const trackVideoInteraction = (eventName, additionalEventProps = {}) => {
        const videoId = getAssetNameFromUrl((video === null || video === void 0 ? void 0 : video.videoUrl) || '');
        if (videoId && (video === null || video === void 0 ? void 0 : video.videoUrl) && trackingParams && mainEntity && analyticsTrack) {
            const eventProps = Object.assign(Object.assign(Object.assign({}, buildTrackingParams({ trackingParams, mainEntity })), { videoId, video: video.videoUrl, videoTitle: title }), additionalEventProps);
            analyticsTrack(eventName, eventProps);
        }
    };
    const handleVideoPlay = () => {
        trackVideoInteraction(AnalyticsTrackingEvent.LANDING_PAGE_VIDEO_PLAY_STARTED);
    };
    const handleVideoPause = ({ currentTime }) => {
        trackVideoInteraction(AnalyticsTrackingEvent.LANDING_PAGE_VIDEO_PLAY_PAUSED, {
            videoPlayDuration: parseFloat(currentTime.toFixed(2)),
        });
    };
    const handleVideoEnd = ({ duration }) => {
        trackVideoInteraction(AnalyticsTrackingEvent.LANDING_PAGE_VIDEO_PLAY_ENDED, {
            videoPlayDuration: parseFloat(duration.toFixed(2)),
        });
    };
    const handleTrackRetailerPDPNavigation = () => {
        if (retailerPDPNavigationEventParams && trackingParams && !!analyticsTrack) {
            const params = Object.assign(Object.assign({}, trackingParams), retailerPDPNavigationEventParams);
            trackRetailerProductPageEvent({
                trackingEventAction: 'navigateToRetailerProductPage',
                trackingParams: params,
                analyticsTrack,
            });
        }
    };
    useEffect(() => {
        let autoRedirectTimeout = undefined;
        if (!!(phoneInput === null || phoneInput === void 0 ? void 0 : phoneInput.autoRedirectOnSuccess) && (phoneInput === null || phoneInput === void 0 ? void 0 : phoneInput.redirectionUrl) && step === 1) {
            autoRedirectTimeout = setTimeout(() => {
                window.open(phoneInput === null || phoneInput === void 0 ? void 0 : phoneInput.redirectionUrl);
            }, 2000);
        }
        return () => {
            if (autoRedirectTimeout) {
                clearTimeout(autoRedirectTimeout);
            }
        };
    }, [phoneInput === null || phoneInput === void 0 ? void 0 : phoneInput.autoRedirectOnSuccess, phoneInput === null || phoneInput === void 0 ? void 0 : phoneInput.redirectionUrl, step]);
    return (jsx(PopupDrawer, Object.assign({ open: open, onClose: handleClose }, { children: step === 0 ? (jsxs(ProductPageDialogContent, Object.assign({ title: title, secondTitle: secondTitle, subtitle: subtitle, showIcon: showIcon, imageUrl: imageUrl, imageSize: imageSize, sx: {
                paddingBottom: `${sharePage && video ? '30' : '48'}px`,
            } }, { children: [phoneInput && handleSendText && (jsx("div", Object.assign({ className: "phone-input-container" }, { children: jsx(BrandclubPhoneInput, { userProfile: userProfile, hasHeader: false, buttonText: 'Get App', variant: BCPhoneInputVariant.SM, onTextSent: onTextSent, handleSendText: handleSendText }) }))), redirect && (jsx(ArrowLink, Object.assign({}, {
                    text: redirect.text,
                    url: redirect.url,
                    onTextClick: () => {
                        if (trackRetailerPDPNavigation) {
                            handleTrackRetailerPDPNavigation();
                        }
                        window.open(redirect.url, '_blank');
                    },
                }))), sharePage && (jsx("div", Object.assign({ className: "share-container" }, { children: jsx(SharePage, { url: sharePageUrl || window.location.href, onShareLinkCopied: onShareLinkCopied }) }))), rewardTableRows && jsx(RewardTable, { rows: rewardTableRows, containerStyle: { marginTop: 10 } }), video && (jsx("div", Object.assign({ className: "video-container", style: { margin: `${sharePage && video ? '0' : '12'}px auto 0` } }, { children: jsx(BrandclubVideo, { videoUrl: video.videoUrl, posterUrl: video.coverImageUrl, canPlay: true, onPlay: handleVideoPlay, onPause: handleVideoPause, onEnd: handleVideoEnd }) })))] }))) : (jsx(ProductPageDialogSuccess, { handleClose: handleClose, closeDialogText: phoneInput === null || phoneInput === void 0 ? void 0 : phoneInput.closeDialogText, redirectionText: phoneInput === null || phoneInput === void 0 ? void 0 : phoneInput.redirectionText, redirectionUrl: Link ? phoneInput === null || phoneInput === void 0 ? void 0 : phoneInput.redirectionUrl : undefined })) })));
};
const ProductPageDialog = (props) => {
    const location = window.location;
    useEffect(() => {
        props.popupDrawerProps.open && props.popupDrawerProps.onClose();
        // close the dialog whenever the location changes
    }, [location]);
    return jsx(ProductPageDialogMain, Object.assign({}, props));
};

export { ProductPageDialog, ProductPageDialogMain };
//# sourceMappingURL=ProductPageDialog.js.map
